import { type QuestionBulkResult } from '@aysar/contracts';

/** The cache tags of the questions api, as RTK Query describes them. */
type QuestionTag = 'QuestionList' | { type: 'Question'; id: string };

/**
 * What a write over a SET of questions invalidates.
 *
 * The list, plus **every question the write actually changed** — and the second
 * half is the one that was missing. A bulk activate/deactivate changes
 * `isActive` on up to 500 questions; dropping only `QuestionList` left an editor
 * already open on one of them showing the old status until something else
 * happened to refetch it. The section-wide visibility write had the right shape
 * from the start, which is precisely why this is one function used by both
 * rather than a shape copied a second time.
 *
 * `changedIds` and not `matched`: re-invalidating a row the server decided not
 * to write is a refetch nobody asked for, and the api reports the two numbers
 * separately so a client can tell them apart.
 */
export function bulkResultTags(result: QuestionBulkResult | undefined): QuestionTag[] {
  return [
    'QuestionList',
    ...(result?.changedIds ?? []).map((id) => ({ type: 'Question' as const, id })),
  ];
}
